module.exports = __webpack_public_path__ + "static/buymeacoffee-0f8ea335dea00b54971aa81e3901c14e.png";